<template>
  <div class="box box_mm">
    <div class="box_main">
      <div class="search_box">
        <div class="search_item">
          <span style="width: 0.8rem">标题：</span>
          <el-input
            v-model="searchinput"
            placeholder="请输入"
            style="width: 2rem"
          ></el-input>
        </div>
        <div class="search_item">
          <span style="width: 0.8rem">分类：</span>
          <el-select
            v-model="searchfenlei"
            placeholder="请选择"
            filterable
            clearable
            style="width: 2.3rem"
            @change="search"
          >
            <el-option
              v-for="item in classifyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="search_item">
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="success" @click="usedcarexport">导出</el-button>

          <!-- <el-button type="success" @click="addnew">新建公文处理单</el-button> -->
        </div>
      </div>
      <div class="box_cont">
        <div class="btn_list"></div>
        <div style="height: 76vh; box-sizing: border-box">
          <MyTable
            ref="zjlist"
            :tableData="tableData"
            :tableHeader="tableHeader"
            :showbm="true"
            :czwidth="310"
            @getdata="gettable"
            @changswitch="changswitch"
          >
            <template slot="btns" slot-scope="{ scope }">
              <el-button
                @click="showdetail2(scope.row)"
                type="primary"
                size="mini"
                >详情</el-button
              >
              <el-button
                @click="showdetail(scope.row)"
                type="primary"
                size="mini"
                >查看文件</el-button
              >
              <el-button
                @click="guaban(scope.row, false)"
                v-if="scope.row.gbtype != '挂办'"
                type="primary"
                size="mini"
                >挂办</el-button
              >
              <el-button
                @click="guaban(scope.row, true)"
                v-if="scope.row.gbtype == '挂办'"
                type="danger"
                size="mini"
                >取消挂办</el-button
              >
            </template>
          </MyTable>
        </div>
      </div>
    </div>

    <detail
      v-if="showtcdetail"
      :id="nowid"
      @closedetail="showtcdetail = false"
    ></detail>

    <detail_tcsj
      v-if="showtcsjdetail"
      :id="nowid"
      @closedetail="showtcsjdetail = false"
    ></detail_tcsj>
  </div>
</template>

<script>
import detail from "./detail_tc";
import detail_tcsj from "./detail_tcsj";
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { Loading } from "element-ui";

export default {
  components: {
    detail,
    detail_tcsj,
  },
  data() {
    return {
      searchinput: "",
      searchfenlei: "",
      tableHeader: [
        {
          prop: "id",
          name: "序",
          width: "50",
        },
        {
          prop: "name",
          name: "标题",
          width: "",
        },
        {
          prop: "sqmytype_name",
          name: "所属类别",
          width: "150",
        },
        {
          prop: "sqmychannel_name",
          name: "来源渠道",
          width: "150",
        },
        {
          prop: "user_name",
          name: "发起人",
          width: "120",
        },
        {
          prop: "gbtype",
          name: "是否挂办",
          width: "120",
        },
        {
          prop: "state",
          name: "状态",
          width: "120",
          type: "sqmy_type",
        },
        {
          prop: "createtime",
          name: "创建时间",
          width: "150",
        },
      ],
      classifyData: [],
      tableData: [],
      showtcdetail: false,
      showtcsjdetail: false,
      nowid: "",
    };
  },
  mounted() {
    this.$post({
      url: "/api/sqmytype/index",
      params: {
        p: 1,
        size: 9999,
      },
    }).then((res) => {
      this.classifyData = res.list;
    });
    this.gettable();
  },
  methods: {
    usedcarexport() {
      this.loading = Loading.service({
        lock: true,
        text: "导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$post({
        url: "/api/sqmy/dcquan",
        params: {
          name: this.searchinput,
          sqmytype_id: this.searchfenlei,
          hqtype: 2,
          state: 6,
        },
      })
        .then((res) => {
          res.list = res.list.map((item) => {
            item.state_name = this.stateFun(item.state);
            return item;
          });
          this.daochu(res.list);
        })
        .catch((err) => err);
    },
    stateFun(sta) {
      let tet = "";
      switch (sta) {
        case 1:
          tet = "待审核";
          break;
        case 2:
          tet = "待区政协审核";
          break;
        case 3:
          tet = "不予采纳";
          break;
        case 4:
          tet = "区政协采纳";
          break;
        case 5:
          tet = "区政协不予采纳";
          break;
        case 6:
          tet = "政府办采纳";
          break;
        case 7:
          tet = "政府办不予采纳";
          break;
        case 8:
          tet = "承办单位反馈";
          break;
        case 9:
          tet = "政府办反馈";
          break;
        case 10:
          tet = "已完结";
          break;
        case 11:
          tet = "采纳";
          break;

        default:
          break;
      }
      return tet;
    },
    daochu(arr) {
      // 数据数组
      let data = arr;

      // 表头名称映射
      const header = {
        name: "标题",
        sqmytype_name: "所属类别",
        sqmychannel_name: "来源渠道",
        user_name: "发起人",
        state_name: "状态",
        createtime: "创建时间",
      };

      // 创建工作簿对象
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet([Object.values(header)]);

      // 设置表头样式，可选
      const headerStyle = {
        font: { bold: true },
        fill: { patternType: "solid", fgColor: { rgb: "00BFFF" } },
      };
      XLSX.utils.format_cell(worksheet["A1"], headerStyle);

      // 根据数据生成表格内容
      for (let i = 0; i < data.length; i++) {
        const row = [];
        for (const key in header) {
          if (header.hasOwnProperty(key)) {
            row.push(data[i][key]);
          }
        }
        XLSX.utils.sheet_add_aoa(worksheet, [row], { origin: -1 });
      }

      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 导出 Excel 文件
      XLSX.writeFile(workbook, "社情民意审核数据.xlsx");
      this.loading.close();
      this.$message.success("导出成功");
    },
    guaban(row, TF) {
      this.$confirm(TF ? "请确认是否取消挂办?" : "请确认是否挂办?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post({
            url: "/api/sqmy/guaban",
            params: {
              id: row.id,
            },
          }).then((res) => {
            this.gettable();
          });
        })
        .catch(() => {});
    },
    showdetail2(row) {
      this.nowid = row.id;
      this.showtcsjdetail = true;
    },
    showdetail(row) {
      this.nowid = row.id;
      this.showtcdetail = true;
    },
    postdata(row) {},
    showeidt(row) {
      this.$router.push("/system/get_file/edit?id=" + row.id);
    },
    changswitch(row) {
      this.$post({
        url: "/api/room/edit",
        params: row,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "操作成功!",
        });
        this.gettable();
      });
    },
    search() {
      this.$refs.zjlist.inputpage = 1;
      this.gettable();
    },
    gettable() {
      this.$post({
        url: "/api/sqmy/quanindex",
        params: {
          name: this.searchinput,
          sqmytype_id: this.searchfenlei,
          p: this.$refs.zjlist.inputpage,
          hqtype: 2,
          state: 8,
          size: this.$refs.zjlist.pagesize,
        },
      }).then((res) => {
        res.list.map((item) => {
          item.state = 11;
          item.gbtype = item.gbtype == 2 ? "挂办" : "";
          return item;
        });
        this.tableData = res.list;
        this.$refs.zjlist.total = res.count;
      });
    },
    addnew() {
      this.$router.push("/system/get_file/add");
    },
    showdate(row) {
      this.$refs.myroomdate.dialogVisible = true;
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style lang="scss" scoped>
@import "list.scss";
</style>
